import { monthlyFootnoteFormatter } from 'app/components/questions/base'
import { DoubleQuestion } from 'app/components/questions/double'
import { genericChangeCTA } from 'app/containers/PipelineSection/Expenses'
import * as React from 'react'

const ClothingQuestionsGroup = () => (
  <DoubleQuestion
    header="Clothing"
    icon="fa fa-fw fa-bath"
    headerDescription="In this section, you'll be entering your expenses for clothing."
    question1={{
      placeholder: 'Enter your current annual clothing expenses',
      name: 'expenses.clothing.{member}.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
    }}
    itemFootnoteFormatter={monthlyFootnoteFormatter}
    question2={{
      placeholder: 'Enter your spouse\'s current annual clothing expenses',
      name: 'expenses.clothing.{spouse}.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
      needsSpouse: true
    }}
    option={{
      callToAction: genericChangeCTA,
      question1: {
        placeholder: 'Enter your annual clothing expense during retirement',
        name: 'expenses.clothing.{member}.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
      },
      question2: {
        placeholder: 'Enter your spouse\'s annual clothing expense during retirement',
        name: 'expenses.clothing.{spouse}.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
        needsSpouse: true
      },
      itemFootnoteFormatter: monthlyFootnoteFormatter
    }} />
)

const WardrobeQuestionsGroup = () => (
  <DoubleQuestion
    header="Grooming"
    icon="fa fa-fw fa-bath"
    headerDescription="In this section, you'll be entering your expenses for grooming."
    question1={{
      placeholder: 'Enter your current monthly grooming expenses',
      name: 'expenses.grooming.{member}.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
    }}
    question2={{
      placeholder: 'Enter your spouse\'s current monthly grooming expenses',
      name: 'expenses.grooming.{spouse}.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
      needsSpouse: true
    }}
    option={{
      callToAction: genericChangeCTA,
      question1: {
        placeholder: 'Enter your monthly grooming expenses during retirement',
        name: 'expenses.grooming.{member}.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly'
      },
      question2: {
        placeholder: 'Enter your spouse\'s monthly grooming expenses during retirement',
        name: 'expenses.grooming.{spouse}.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly',
        needsSpouse: true
      }
    }} />
)

export {
  ClothingQuestionsGroup,
  WardrobeQuestionsGroup,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Personal/index.tsx